import { apiClient, API_CONFIG } from '../../core';
import type { ApiResponse } from '../../shared';
import { buildRequiredQueryString } from '../../shared/queryBuilder';
import type { LC_GetEmployeeEnabledLocationsOut, LC_GenerateAttendanceMapIn, LC_GenerateAttendanceMapOut } from './location.types';


export class LocationService {
  /**
   * Get enabled locations for an employee
   * GET /v{version}/employees/{employeeId}/locations
   * @param employeeId - The employee ID
   */
  async getEmployeeEnabledLocations(
    employeeId: number,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_GetEmployeeEnabledLocationsOut>> {
    return apiClient.get<LC_GetEmployeeEnabledLocationsOut>(
      API_CONFIG.ENDPOINTS.LOCATION.GET_EMPLOYEE_ENABLED_LOCATIONS(employeeId),
      { signal },
    );
  }

  async generateMap(
    input: LC_GenerateAttendanceMapIn,
  ): Promise<ApiResponse<LC_GenerateAttendanceMapOut>> {
    const queryString = buildRequiredQueryString(
      {
        latitude: input.latitude,
        longitude: input.longitude,
        zoomLevel: input.zoomLevel,
        mapWidth: input.mapWidth,
        mapHeight: input.mapHeight,
      },
      ['latitude', 'longitude'],
    );
    
    return apiClient.get<LC_GenerateAttendanceMapOut>(
      `${API_CONFIG.ENDPOINTS.LOCATION.GENERATE_MAP}${queryString}`,
    );
  }
}

export const locationService = new LocationService();
